import PropTypes from "prop-types";
const PageHeader = ({ title }) => {
  return (
    <h1
      data-testid="page-header"
      className="mb-4 text-3xl font-bold text-left text-lighterGrey">
      {title}
    </h1>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
};

export default PageHeader;
